import { CONST_EINHEITEN, InputMaskType } from "../../../../classes/learnware/LearnwareEnums";
export class WordTaskMask {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get firstWording() {
        if (this.wordTask.wordings.length === 0)
            return "";
        return this.wordTask.wordings[0].wordingString;
    }
    get activeInputMask() {
        if (this.wordTask.inputMask)
            return this.wordTask.inputMask;
        return this.autoInputMask;
    }
    get autoInputMask() {
        const firstWording = this.firstWording;
        if (firstWording.length === 0)
            return "";
        // automatically detect input mask
        if (isNormalInteger(firstWording)) {
            return InputMaskType.Integer;
        }
        const decimalParts = firstWording.split(",");
        if (decimalParts.length === 2 &&
            isNormalInteger(decimalParts[0]) &&
            isNormalInteger(decimalParts[1])) {
            return InputMaskType.Decimal;
        }
        if (firstWording.endsWith('Uhr') && firstWording.includes('.')) {
            return InputMaskType.Uhrzeit;
        }
        const passendeEinheit = CONST_EINHEITEN.find((einheit) => firstWording.endsWith(einheit));
        if (passendeEinheit && isNormalInteger(firstWording.split(passendeEinheit)[0].split(",")[0])) {
            return InputMaskType.Einheit;
        }
        /*
        if (firstWording.endsWith('€') &&  firstWording[firstWording.length-4] === ',' && isNormalInteger(firstWording.split('€')[0].split(',')[0])) {
          return InputMaskType.Euro;
        }
    */
        if (firstWording.endsWith("ct") &&
            firstWording.includes("€ ") &&
            isNormalInteger(firstWording.split("€ ")[0]) &&
            isNormalInteger(firstWording.split("€ ")[1].split("ct")[0])) {
            return InputMaskType.EuroCent;
        }
        /*
        if (firstWording.endsWith('ct') && isNormalInteger(firstWording.split('ct')[0])) {
          return InputMaskType.Cent;
        }
        if (firstWording.endsWith('ml') && isNormalInteger(firstWording.split('ml')[0])) {
          return InputMaskType.Milliliter;
        }
        if (firstWording.endsWith('l') && isNormalInteger(firstWording.split('l')[0])) {
          return InputMaskType.Liter;
        }
        if (firstWording.endsWith('kg') && isNormalInteger(firstWording.split('kg')[0])) {
          return InputMaskType.Kilogramm;
        }
        if (firstWording.endsWith('g') && isNormalInteger(firstWording.split('g')[0])) {
          return InputMaskType.Gramm;
        }*/
        return "";
    }
}
export function isNormalInteger(str) {
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
}
